import {useEffect} from "react";
import {setTitle} from "./navigation_reducer";
import {useDispatch} from "react-redux";

type TitleProps = {
    title: string
}
export default ({title}: TitleProps) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setTitle(title))
    }, [title])

    return null;
}
